"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.swrConfig = void 0;
/* istanbul ignore file */ /**
 * SWR config
 */ const swrConfig = exports.swrConfig = {
    errorRetryCount: 3,
    errorRetryInterval: 10000,
    focusThrottleInterval: 300000,
    shouldRetryOnError: true,
    suspense: false,
    /* eslint-disable max-params -- library requires too many parameters */ onErrorRetry: (error, key, config, revalidate, param)=>{
        let { retryCount } = param;
        var _error_data_code;
        const statusCode = Number((_error_data_code = error.data.code) !== null && _error_data_code !== void 0 ? _error_data_code : 200);
        if (statusCode >= 400 && statusCode < 500) {
            return;
        }
        const rCount = retryCount !== null && retryCount !== void 0 ? retryCount : 1;
        var _config_errorRetryCount;
        if (rCount >= ((_config_errorRetryCount = config.errorRetryCount) !== null && _config_errorRetryCount !== void 0 ? _config_errorRetryCount : 0)) {
            return;
        }
        setTimeout(()=>void revalidate({
                retryCount: rCount
            }), config.errorRetryInterval);
    }
};
